import React from 'react'
import { classNames } from '~/utils/client/helpers'
import { Detail, Small } from '../../text/Text'

export type CircularStepVerticalProps = React.ComponentProps<'li'> & {
  title?: string
  description?: string
  icon: React.ForwardRefExoticComponent<Omit<React.SVGProps<SVGSVGElement>, 'ref'>>
  className?: string
  isLastStep?: boolean
}

export const CircularStepVertical: React.FC<CircularStepVerticalProps> = ({
  title,
  description,
  className,
  isLastStep = false,
  ...props
}) => {
  return (
    <li key={title} className={classNames(isLastStep ? '' : 'pb-10', 'relative')}>
      {!isLastStep ? (
        <div
          className="absolute left-4 top-4 -ml-px mt-0.5 h-full w-px bg-border-subtle"
          aria-hidden="true"
        />
      ) : null}
      <div className="group relative flex items-start">
        <span className="flex h-9 flex">
          <span className="relative z-10 flex h-8 w-8 items-center justify-center rounded-md bg-white border border-border-subtle border-solid group-hover:bg-surface-hover">
            <props.icon className="h-5 w-5 text-brand" aria-hidden="true" />
          </span>
        </span>
        <div className="ml-4 flex min-w-0 flex-col">
          {title && <Detail className="mb-1">{title}</Detail>}
          {description && <Small>{description}</Small>}
        </div>
      </div>
    </li>
  )
}
